import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import ChunkPickerDoublePage from '@Components/ChunkPicker/ChunkPickerDoublePage';
import GoToPage from '@Components/GoToPage/GoToPage';

import './SuggestModalFooter.scss';

function SuggestModalFooter({ isLoading, opModel, applyChanges, selectPage, currentPage, noData, maxPage }) {
  // eslint-disable-next-line sonarjs/slow-regex
  const formatNumber = (number) => String(number.toFixed().toLocaleString()).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (
    <div className="suggestModal__footer">
      <div className="suggestModal__footer_chunkPicker">
        {!isLoading && !noData && maxPage > 1 && (
          <>
            <ChunkPickerDoublePage onClick={selectPage} min={1} max={maxPage} current={currentPage}>
              <div>{`${formatNumber(currentPage)} of ${formatNumber(maxPage)}`}</div>
            </ChunkPickerDoublePage>
            <GoToPage
              chunksCount={maxPage}
              onClick={(page) => {
                selectPage(page);
              }}
            />
          </>
        )}
      </div>

      <div className="suggestModal__footer_buttons">
        <ButtonWithIcon
          id="suggestModal-footer-transfer"
          data-e2e="suggestModal-footer-transfer"
          className=" u-els-margin-left"
          type="primary"
          sprite="ChevronRight"
          iconRight
          disabled={isEmpty(opModel.selection)}
          onClick={applyChanges}>
          Transfer
        </ButtonWithIcon>
      </div>
    </div>
  );
}

SuggestModalFooter.propTypes = {
  isLoading: PropTypes.bool,
  applyChanges: PropTypes.func.isRequired,
  selectPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  noData: PropTypes.bool,
  maxPage: PropTypes.number,
  opModel: PropTypes.object,
};

export default SuggestModalFooter;
